import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { getCircular } from "../Service/Api";
import LazyLoad from "react-lazyload";

const GlimpseOfTheDay = () => {
  const [filterData, setFilteredData] = useState([]);

  useEffect(() => {
    document.title =
      "Glimpse Of The Day-  St Peters convent School Faridabad Haryana";
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const circularData = await getCircular();
        setFilteredData(circularData || []);
      } catch (error) {
        console.error("Error fetching glimpse data:", error);
      }
    };

    fetchData();
  }, []);

  const glimpseData = (filterData || []).filter((item) => {
    const category = (item?.category || "").replace(/'+/g, "").trim();
    return category === "Glimpse";
  });

  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li> Events </li>
          <li>Glimpse Of The Day </li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Glimpse Of The Day</h1>
            </div>
          </div>

          <div className="row">
            {glimpseData.length > 0 ? (
              glimpseData.map((item, index) => (
                <div
                  className="col-lg-3 col-md-6 col-sm-12 col-12 mb-4"
                  key={item?._id || index}
                >
                  <Link
                    to={`https://webapi.entab.info/api/image/${item?.attachments?.[0]}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="sample-blk">
                      <div>
                        <p>{item?.title}</p>
                        <span>{item?.date}</span>
                      </div>
                      <LazyLoad>
                        <img
                          alt="Glimpse"
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                          className="img-fluid"
                        />
                      </LazyLoad>
                    </div>
                  </Link>
                </div>
              ))
            ) : (
              <div className="col-lg-12">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/comingsoon.jpg"
                  className="img-fluid mx-auto d-block"
                  alt="Coming Soon"
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default GlimpseOfTheDay;
